(function () {
  const COMPANY_ID = 'VW6cGD';
  const REVISION = '2026-07-15';

  function normalise(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isSoldOut(submitButton) {
    if (!submitButton || !submitButton.disabled) return false;
    const label = normalise(submitButton.querySelector('span')?.textContent || submitButton.textContent);
    const translated = normalise(window.variantStrings?.soldOut || 'sold out');
    return label === translated || label.includes('sold out') || label.includes('out of stock');
  }

  function syncWrapper(wrapper) {
    const submitButton = wrapper.querySelector('.product-form__submit');
    const notifyButton = wrapper.querySelector('[data-hce-bis-trigger]');
    const dynamicCheckout = wrapper.querySelector('[data-hce-dynamic-checkout]');
    const soldOut = isSoldOut(submitButton);

    if (notifyButton) notifyButton.hidden = !soldOut;
    if (dynamicCheckout) dynamicCheckout.hidden = !!submitButton?.disabled;
  }

  function openDialog(wrapper, trigger) {
    const id = trigger?.dataset.hceBisDialog;
    const dialog = id ? document.getElementById(id) : wrapper.querySelector('[data-hce-bis-dialog]');
    if (!dialog) return;

    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hce-bis-open');
    window.setTimeout(() => dialog.querySelector('input[type="email"]')?.focus(), 0);
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.hidden = true;
    dialog.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hce-bis-open');
  }

  async function submitBackInStock(form, wrapper) {
    const emailInput = form.querySelector('input[type="email"]');
    const status = form.querySelector('[data-hce-bis-status]');
    const submit = form.querySelector('button[type="submit"]');
    const variantInput = wrapper.querySelector('.product-variant-id');
    const email = (emailInput?.value || '').trim();
    const variantId = (variantInput?.value || '').trim();

    if (!emailInput?.checkValidity()) {
      emailInput?.reportValidity();
      return;
    }

    if (!variantId) {
      if (status) status.textContent = form.dataset.hceMsgSelect || 'Please select a product first.';
      return;
    }

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    const originalText = submit?.textContent || 'NOTIFY ME';
    if (submit) {
      submit.disabled = true;
      submit.textContent = (form.dataset.hceMsgSubmitting || 'Submitting...').toUpperCase();
    }
    if (status) status.textContent = '';

    try {
      const response = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(COMPANY_ID),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'revision': REVISION
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) throw new Error('Back in stock subscription failed with status ' + response.status);

      if (status) status.textContent = form.dataset.hceMsgSuccess || 'Thank you. We’ll email you when this product is back in stock.';
      if (emailInput) emailInput.value = '';
      if (submit) submit.hidden = true;
    } catch (error) {
      console.error('[HCE back in stock]', error);
      if (status) status.textContent = form.dataset.hceMsgError || 'We could not save your alert. Please try again.';
      if (submit) {
        submit.disabled = false;
        submit.textContent = originalText;
      }
    }
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.hceBisInitialised === 'true') return;
    wrapper.dataset.hceBisInitialised = 'true';

    const submitButton = wrapper.querySelector('.product-form__submit');
    const trigger = wrapper.querySelector('[data-hce-bis-trigger]');
    const dialog = wrapper.querySelector('[data-hce-bis-dialog]');
    const bisForm = wrapper.querySelector('[data-hce-bis-form]');

    syncWrapper(wrapper);

    if (submitButton) {
      const observer = new MutationObserver(() => syncWrapper(wrapper));
      observer.observe(submitButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    trigger?.addEventListener('click', () => openDialog(wrapper, trigger));

    dialog?.querySelectorAll('[data-hce-bis-close]').forEach((element) => {
      element.addEventListener('click', () => closeDialog(dialog));
    });

    bisForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      submitBackInStock(bisForm, wrapper);
    });
  }

  function init() {
    document.querySelectorAll('.product-buy-buttons-wrapper').forEach(initWrapper);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  // Delegated close handler keeps the X and backdrop working even when
  // Shopify replaces product-section markup after variant changes.
  document.addEventListener('click', (event) => {
    const closeControl = event.target.closest('[data-hce-bis-close]');
    if (!closeControl) return;

    const dialog = closeControl.closest('[data-hce-bis-dialog]');
    if (!dialog) return;

    event.preventDefault();
    event.stopPropagation();
    closeDialog(dialog);
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-hce-bis-dialog]:not([hidden])').forEach(closeDialog);
  });

  init();
})();